import gql from 'graphql-tag';

import {User, Part} from './fragments';

export const SaveUserMutation = gql`
  mutation saveUser(
    $_id: String
    $active: Boolean
    $email: String!
    $password: String
    $phone: String!
    $firstName: String!
    $lastName: String!
    $role: String!
  ) {
    saveUser(
      _id: $_id
      email: $email
      active: $active
      password: $password
      phone: $phone
      firstName: $firstName
      lastName: $lastName
      role: $role
    ) {
      ...User
    }
  }
  ${User}
`;

export const SaveUserMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: user =>
      mutate({
        variables: {_id, ...user},
        updateQueries: {
          allUsers: ({allUsers, ...prev}, {mutationResult: {data: {saveUser}}}) =>
            _id
              ? {...prev, allUsers: allUsers.map(user => (user._id === _id ? saveUser : user))}
              : {...prev, allUsers: [saveUser, ...allUsers]},
        },
      }),
  }),
};

export const SellPartMutation = gql`
  mutation sellPart($_id: ID!) {
    sellPart(_id: $_id) {
      ...Part
    }
  }
  ${Part}
`;

export const SellPartMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    sellPart: variables =>
      mutate({
        variables: {_id, ...variables},
        updateQueries: {
          reviewParts: ({allParts, ...prev}, {mutationResult: {data: {sellPart}}}) => {
            return {...prev, allParts: allParts.filter(part => part._id !== sellPart._id)};
          },
        },
      }),
  }),
};



// WEBPACK FOOTER //
// ./src/qql-shared/mutations.js